import types from './mutation-types';
import CategoryService from '@/services/category-service.js';
import { isNil } from 'lodash';
import { CancelToken } from 'axios';

const actions = {
	fetchAll({ commit }) {
		commit(types.FETCH_LIST_START);

		CategoryService.get({ total: 100 })
			.then(categories => commit(types.FETCH_LIST_SUCCESS, categories))
			.catch(error => commit(types.FETCH_LIST_ERROR, error));
	}
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/category-list/actions.js